import imgdonation from '../../assets/img/donation/donation2-1.png';


import React from 'react';

const VideoArea   = () => {
  return (
    <>

<div className="video-area-2 space bg-theme-dark">
  <div
    className="shape-mockup video-bg-shape2-1"
    data-top={0}
    data-left={0}
    data-bottom={0}
  >
    <img src="assets/img/shape/video_shape2_1.png" alt="img" />
  </div>
  <div className="container">
    <div className="row gy-40 gx-80 justify-content-between">
      <div className="col-lg-6">
        <div className="title-area mb-35">
          <span className="sub-title after-none before-none">
            {/* Make a Donations{" "} */}
          </span>
          <h2 className="sec-title text-white">
          MAIN STRENGTHS OF OUR ORGANIZATION 
          </h2>
          <p className="text-light">
            <ul>
    	<li>Devoted trained staff for implementing Rural developmental activates;</li>
      <li>Strong hold in Panchayati Raj Institutions and State Minority Commission of Madhya Pradesh, Bhopal, (M.P.); </li>
      <li>Awakened women SHGs, Co-Operatives, Volunteers, Partner CBBOs/NGOs/FPOs;  </li>
      <li>Network of 200 Artisans, 6 FPOs, 1 LOGF, 10 SHGs, 2 Co-operatives in Madhya Pradesh. </li>
  </ul>
          </p>
        </div>
        <div className="donation-card style200">
          <div className="box-thumb">
            <img src={imgdonation} alt="image" />
          </div>
          <div className="box-content">
            {/* <h3 className="box-title"> */}
              {/* <a href="blog-details.html">
                Big charity: build school for poor children
              </a>
            </h3>
            <p>Stay informed about our upcoming events and campaigns.</p> */}
            {/* <div className="donation-card_progress-wrap">
              <div className="progress">
                <div className="progress-bar" style={{ width: "85%" }}>
                  <div className="progress-value">85%</div>
                </div>
              </div>
              <div className="donation-card_progress-content">
                <span className="donation-card_raise">$5,00.00 Raised</span>
                <span className="donation-card_goal text-theme2">
                  Goal - $10,00.00
                </span>
              </div>
            </div> */}
            {/* <a href="blog-details.html" className="th-btn style6">
              Donate Now <i className="fas fa-arrow-up-right ms-2" />
            </a> */}
          </div>
        </div>
      </div>
      <div className="col-lg-6">
        <div className="video-thumb2-1 video-box-center">
          <img src="assets/img/normal/video-thumb2-1.jpg" alt="img" />
          {/* <h2 className="video-title">Watch Now</h2> */}
          <a
            href="https://www.youtube.com/watch?v=NHsXobbyW8I"
            className="play-btn style5 popup-video"
          >
            <i className="fa-sharp fa-solid fa-play" />
          </a>
        </div>
      </div>
    </div>
  </div>
</div>
 
    </>
  );
};

export default VideoArea;









